import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";

export type LoginPageSliceStateKeys = "";
export interface ILoginPageSliceState extends IRouteReducerSliceStateInit {
  state?: {
    heroTitle?: string;
  };
}
const initialState: ILoginPageSliceState = {};

const loginPageSlice = createSlice({
  name: "login_page_slice",
  initialState: initialState,
  reducers: {
    /* Cleans Up state with multiple state keys */
    cleanupRoot: (state, action: PayloadAction<{ keys: LoginPageSliceStateKeys[] }>) => {
      for (let i = 0; i < action.payload.keys.length; i++) {
        state[action.payload.keys[i]] = null;
      }
    },
  },
});

export const { cleanupRoot } = loginPageSlice.actions;

export default loginPageSlice.reducer;
